import React from 'react';
import { Loader, BaasicTable, BaasicButton, BaasicHeader, Collapsible } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ReceivingHistoryLogList } from 'themes/modules/receiving/pages';

const ReceivingDetailTemplate = ({ receivingDetailViewStore, t }) => {
	const {
		receiving,
		receivingStore,
		tableData,
		loading,
		showActions,
		noDataItem,
		rootStore,
		goToEdit,
	} = receivingDetailViewStore;
	if (loading) return <Loader />;
	return (
		<section>
			<div className="container--fluid">
				<BaasicHeader rootStore={rootStore} title={'RECEIVINGDETAILVIEW.LABEL.TITLE'}>
					<BaasicButton
						className="btn btn--white"
						onClick={goToEdit}
						icon="fa fa-edit spc--right--tny"
						authorization="receivingSection.update"
						label="EDIT"
					/>
				</BaasicHeader>
				<div className="order__wrapper">
					<div className="order__header">
						<div className="order__header__wrapper">
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('RECEIVINGDETAILVIEW.LABEL.REF')}</h4>
									<p>{receiving.ref}</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('RECEIVINGDETAILVIEW.LABEL.TYPE')}</h4>
									<p>{receiving.receivingType.name}</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('RECEIVINGDETAILVIEW.LABEL.STATUS')}</h4>
									<p>{receiving.receivingStatus.name}</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">
										{t('RECEIVINGDETAILVIEW.LABEL.ESTIMATEDRECEIVINGDATE')}
									</h4>
									<p>{receiving.estimatedReceivingDate}</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">
										{t('RECEIVINGDETAILVIEW.LABEL.ACTUALRECEIVINGDATE')}
									</h4>
									<p>{receiving.actualReceivingDate}</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('RECEIVINGDETAILVIEW.LABEL.WAREHOUSETO')}</h4>
									<p>
										{receiving.warehouseTo != null ? receiving.warehouseTo.applicationTitle : receiving.warehouseToName}
									</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('RECEIVINGDETAILVIEW.LABEL.WAREHOUSEFROM')}</h4>
									<p>
										{receiving.warehouseFrom != null
											? receiving.warehouseFrom.applicationTitle
											: receiving.warehouseFromName}
									</p>
								</div>
							</div>
							<div className="order__header__column">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('RECEIVINGDETAILVIEW.LABEL.COST')}</h4>
									<p>{receiving.cost}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="order__details">
					<div className="container--fluid">
						<div className="row spc--bottom--xlrg">
							<div className="col col-sml-12">
								<h4 className="order__box__title order__box__title--table">
									{t('RECEIVINGDETAILVIEW.LABEL.RECEIVINGPRODUCTS')}
								</h4>
								<BaasicTable
									{...{
										data: receiving.receivingProducts.slice(),
										tableData,
										listStore: receivingStore,
										actions: receivingDetailViewStore,
										showActions,
										noDataItem,
									}}
								/>
							</div>
						</div>
						<div className="spc--top--med">
							<Collapsible title={t('LOGHISTORY')}>
								<ReceivingHistoryLogList />
							</Collapsible>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(ReceivingDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/ReceivingDetailTemplate.jsx